import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { formatCurrency } from '../../../utils';

const CustomizedSwal = withReactContent(Swal);

export default function onRefundClicked(transaction, onRefund) {
  const { id, event } = transaction;
  const amount = transaction.amount / 100.0;

  CustomizedSwal.fire({
    title: 'Refund',
    html: <RefundForm amount={amount} eventName={event.name} />,
    confirmButtonText: 'Refund',
    confirmButtonColor: '#0997ba',
    showCancelButton: true,
    input: 'number',
    inputLabel: 'Refund Amount',
    inputAttributes: {
      min: 0,
      max: amount,
    },
    inputValidator: (value) => {
      if (!value) {
        return 'You need to write something!';
      }
      if (value > amount || value < 0) {
        return `Invalid amount! Value must be between $0 and $${amount}`;
      }
      return '';
    },
  }).then((result) => {
    const refundValue = parseFloat(result.value);
    if (result.isConfirmed && refundValue > 0) onRefund(id, refundValue);
  });
}

function RefundForm({ amount, eventName }) {
  return (
    <Grid container>
      <Grid item xs={12}>
        Are you sure you want to refund <strong>{eventName}</strong>?
      </Grid>
      <Grid item xs={12}>
        <Typography>Transaction Amount: {formatCurrency(amount)}</Typography>
      </Grid>
    </Grid>
  );
}

RefundForm.propTypes = {
  amount: PropTypes.number.isRequired,
  eventName: PropTypes.string.isRequired,
};
